export default __webpack_public_path__ + "static/poster-5e76377c7246a54bc6c40a2481d191d0.png";